module.exports = __webpack_public_path__ + "img/7passenger_driving.621754a7.svg";